import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { UtenteComponent } from './utente/utente.component';
import { AdminGuard } from './admin.guard';

const routes: Routes = [
  {path: '', component: LoginComponent},
  {path: 'utente', 
    canActivate: [AdminGuard],
    component: UtenteComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
